import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {first, take} from "rxjs/operators";
import {PermissionsTag} from "../interface/permissions-tag";
import {ListResponse} from "../interface/response/list-response";
import {UserPermissions} from "../interface/user-permissions";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class PermissionTagsService {
  public readonly tagsDictSubject: ReplaySubject<Array<PermissionsTag>> = new ReplaySubject();
  public readonly tagListSubject: ReplaySubject<CountedAndPaginated<PermissionsTag>>
    = new ReplaySubject<CountedAndPaginated<PermissionsTag>>(1);
  loaded = false;
  userPermissionss: UserPermissions;


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    private auth: AuthService,
  ) {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
        this.loadDict();
      });
  }

  public loadDict(): void {
    if (this.userPermissionss.asf_360.read) {
    this.httpClient.get('/rest/crm/asf360/dictionary/permission-tag-list')
      .pipe(take(1))
      .subscribe((result: ListResponse<PermissionsTag>) => {
        this.tagsDictSubject.next(result.items);
        this.loaded = true;
      });
    }
  }

  public getTagDictSubject(): ReplaySubject<Array<PermissionsTag>> {
    return this.tagsDictSubject;
  }

  public send(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/asf360/permission-tag`, formData)
      .pipe(
        take(1)
      );
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/asf360/permission-tag-list?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<PermissionsTag>) => {
        this.tagListSubject.next(result);
      });
  }

  public getTagListSubject(): ReplaySubject<CountedAndPaginated<PermissionsTag>> {
    return this.tagListSubject;
  }

  public getDict(id: number): Observable<PermissionsTag> {
    this.loadIfNotLoaded();
    const dictObservable: ReplaySubject<PermissionsTag> = new ReplaySubject<PermissionsTag>(1);

    this.tagsDictSubject.pipe(first())
      .subscribe((items: PermissionsTag[]) => {
        items.some((el: PermissionsTag) => {
          if (el.id == id) {
            dictObservable.next(el);
            dictObservable.complete();
            return true;
          }

          return false;
        });

        dictObservable.complete();
      });

    return dictObservable.pipe(first());
  }

  public reloadDict(id: number): Observable<PermissionsTag> {
    this.loadDict();
    const dictObservable: ReplaySubject<PermissionsTag> = new ReplaySubject<PermissionsTag>(1);

    this.httpClient.get('/rest/crm/asf360/dictionary/permission-tag-list')
      .pipe(take(1))
      .subscribe((result: ListResponse<PermissionsTag>) => {
        this.tagsDictSubject.next(result.items);
        result.items.some((el: PermissionsTag) => {
          if (el.id == id) {
            dictObservable.next(el);
            dictObservable.complete();
            return true;
          }

          return false;
        });
        dictObservable.complete();
      });

    return dictObservable.pipe(first());
  }

  private loadIfNotLoaded(): void {
    if (!this.loaded) {
      this.loadDict();
    }
  }
}
